var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProjeto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3151 3.47639C10.3735 3.45138 10.4363 3.43848 10.4998 3.43848C10.5633 3.43848 10.6261 3.45138 10.6845 3.47639L16.6332 6.02623C16.7949 6.0955 16.7949 6.32462 16.6332 6.39389L10.5786 8.98873C10.5283 9.01029 10.4713 9.01029 10.421 8.98873L4.36639 6.39388C4.20477 6.32462 4.20477 6.0955 4.36638 6.02623L10.3151 3.47639ZM3.74753 7.1489C3.61556 7.09234 3.46875 7.18915 3.46875 7.33273V14.2199C3.46875 14.4074 3.58125 14.5761 3.7528 14.6511L9.75229 17.2222C9.88427 17.2787 10.0311 17.1819 10.0311 17.0383V9.97373C10.0311 9.89372 9.9834 9.82141 9.90986 9.7899L3.74753 7.1489ZM10.9685 9.97373C10.9685 9.89372 11.0162 9.82141 11.0898 9.7899L17.2521 7.1489C17.3841 7.09234 17.5309 7.18915 17.5309 7.33273V14.2199C17.531 14.3117 17.5041 14.4015 17.4536 14.4781C17.4031 14.5548 17.3312 14.6149 17.2468 14.6511L11.2473 17.2222C11.1154 17.2787 10.9685 17.1819 10.9685 17.0383V9.97373Z",
    fill: "#6796CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProjeto);
export default __webpack_public_path__ + "static/media/IconProjeto.5c7387b17c4951e971194bf636adad93.svg";
export { ForwardRef as ReactComponent };